import { T } from "@repo/transifex";
import { type Currency } from "~/api/products/types";
import { toast } from "~/components/hooks/use-toast";
import { priceFormatter } from "~/utils/price-formatter";

type ShowInsufficientBalanceToastArgs = {
  shortfallInclVat: number;
  productName: string;
  currency: Currency;
  locale: string;
};

/** Wording matches till-app's toast copy for the same refusal. */
export function showInsufficientBalanceToast({
  shortfallInclVat,
  productName,
  currency,
  locale
}: ShowInsufficientBalanceToastArgs) {
  toast({
    variant: "destructive",
    title: (
      <T
        _str="Insufficient balance for {product} ({amount} missing)"
        product={productName}
        amount={priceFormatter({ value: shortfallInclVat, currency, locale })}
      />
    )
  });
}
